import type { ReactNode } from 'react'

/**
 * `p.lead` inside `.acard` → `auth-card-lead` (process/08-COMPONENT-CATALOGUE.md). "The card's
 * one-paragraph explanation." margin-bottom 20px → --sp-9 (0 delta); font-size 12px → --fs-body
 * (0 delta); line-height 1.55 → --lh-normal (-0.05 delta, the map's own recorded tolerance).
 */
export function AuthCardLead({ children }: { children: ReactNode }) {
  return (
    <p data-cmp="auth-card-lead" className="mb-9 text-body text-tx2 leading-normal">
      {children}
    </p>
  )
}
